import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE } from '../variable';

const INIT_VALUE = {
  page: 1,
  total: 0
};

class BasicList {
  requestMethod = null;

  constructor(requestMethod) {
    if (typeof requestMethod !== 'function') {
      throw 'requestMethod 不能为空';
    }
    this.requestMethod = requestMethod;
  }

  @observable
  list = [];

  @observable
  page = INIT_VALUE.page;
  pageSize = PAGE_SIZE;

  @observable
  isLoading = false;

  listName = '列表名字';
  //假如外部组件组要total则需要被观察
  @observable
  total = INIT_VALUE.total;

  reset() {
    runInAction(() => {
      this.page = INIT_VALUE.page;
      this.list = [];
      this.pageSize = PAGE_SIZE;
      this.isLoading = false;

      this.total = INIT_VALUE.total;
    });
  }

  @action
  async loadList(page, otherParams = {}) {
    if (this.isLoading) {
      return {
        success: false,
        msg: '加载中...'
      };
    }
    this.isLoading = true;
    this.page = page;
    try {
      const result = await this.requestMethod({ page, pageSize: this.pageSize, ...otherParams });
      runInAction(() => {
        this.isLoading = false;
        this.list = result.data.list || [];
        this.total = result.data.total || INIT_VALUE.total;
      });
      return result;
    } catch (e) {
      e = e || {};
      runInAction(() => {
        this.isLoading = false;
      });
      return {
        success: false,
        msg: `${this.listName}：${e.msg || '接口异常'}`,
        code: e.code || 99999
      };
    }
  }

  initLoad(params = {}) {
    if (this.isLoading) {
      return {
        success: false,
        msg: '加载中...'
      };
    }
    return this.loadList(INIT_VALUE.page, params);
  }

  getList() {
    return this.list;
  }

  setListName(listName) {
    this.listName = listName;
  }
}

export default BasicList;



// WEBPACK FOOTER //
// ./src/stores/BasicList.js